// Copyright 2020 Prescryptive Health, Inc.

import { useContext } from 'react';
import { ITelemetryContext, TelemetryContext } from './telemetry.context';

export const useTelemetryContext = (): ITelemetryContext =>
  useContext<ITelemetryContext>(TelemetryContext);
